<h3 class="title-divider">{{ heading | translate }}</h3>
<cap-form-control labelKey="Rechtsgültig">
  <input
    (ngModelChange)="model && (model.rechtsgueltig = $event)"
    [ngModel]="model && model.rechtsgueltig"
    name="historySearchOptions.rechtsgueltig"
    type="checkbox" />
</cap-form-control>
<cap-form-control labelKey="Historisiert">
  <input
    (ngModelChange)="model && (model.historisiert = $event)"
    [ngModel]="model && model.historisiert"
    name="historySearchOptions.historisiert"
    type="checkbox" />
</cap-form-control>
